import React from 'react';

export default function Chat() {
  return (
    <div className='home mb-5 container'>
      <h4 className='mt-4'>Chat</h4>
      <div className='pt-4 col-md-12 pb-4'>
        <iframe
          width='100%'
          height='450'
          is='x-frame-bypass'
          src='https://dashboard.messagebird.com/en/login'
        ></iframe>
      </div>
    </div>
  );
}
